import * as React from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

import './previewContent.scss';


interface PreviewContentProps {
    handleOnCurrentPosition: () => void;
    handleFindByPlace: (placeId: string) => void;
    handleAddSob: () => void;
    hasSobs: boolean;
    handleSetupRoute: () => void;
    handleOnUrlData: () => void;
};

const PreviewContent = ({
    handleOnCurrentPosition,
    handleFindByPlace,
    handleAddSob,
    hasSobs,
    handleSetupRoute,
    handleOnUrlData,
}: PreviewContentProps) => {
    const [opened, setIsopened] = React.useState(null);
    const handleToggle = (index: number) => () => {
        if (index !== opened) {
            setIsopened(index);
        } else {
            setIsopened(null);
        }
    };
    return (
        <div className={'preview-content'}>
            <div className={'preview-item'}>
                <div onClick={handleToggle(1)}>
                    Funkce street GIS mapy
                </div>
                <hr onClick={handleToggle(1)} />
                <div onClick={handleToggle(1)}>
                    {(opened !== 1) ? '>' :' V'}
                </div>
            </div>
            {(opened === 1) && (
                <div className={'preview-item-content'}>
                    <div>
                        <GooglePlacesAutocomplete
                            onSelect={(selected: any) => {
                                console.log('ON SEL => ', selected)
                                handleFindByPlace(selected.place_id);
                            }}
                            autocompletionRequest={{
                                componentRestrictions: {
                                    country: ['cz'],
                                }
                            }}
                        />
                    </div>
                    <div>
                        <button
                            type="button"
                            onClick={handleOnCurrentPosition}
                        >
                            Najit mou pozici
                        </button>
                    </div>
                    <div>
                        <button
                            type="button"
                            onClick={handleAddSob}
                        >
                            Vyznacit markre
                        </button>
                    </div>
                    {(hasSobs) && (
                        <div>
                            <button
                                type="button"
                                onClick={handleSetupRoute}
                            >
                                Vypocitat trasu
                            </button>
                        </div>
                    )}
                    <div>
                        <button
                            type="button"
                            onClick={handleOnUrlData}
                        >
                            Vytvorit mapu z url
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
};

export default PreviewContent;